import request from '../../../request';

export default {
  actions: {
    /**
     * Dashboard data
     */
    dashboard(_, payload) {
      return request.get('dashboard', {
        params: payload,
      });
    },

    getIncomes(_, payload) {
      return request.get('get-incomes', {
        params: payload,
      });
    },

    invoice(_, id) {
      return request.get('invoice/' + id);
    },

    getOrderScreen() {
      return request.get('processes');
    },
    createOrderScreen(_, payload) {
      return request.post('processes', payload);
    },
    create2OrderScreen(_, payload) {
      return request.post('store-processess', payload);
    },
    guncelleOrderScreen(_, payload) {
      return request.post('guncelle-processes', payload);
    },
    createTailorScreen(_, payload) {
      return request.post('tailors', payload);
    },

    createDryScreen(_, payload) {
      return request.post('dry', payload);
    },
    /**
     * Income Management
     */
    incomeManagement(_, parameters) {
      return request.get('incomes', {
        params: parameters,
      });
    },

    getIncomeDependencies() {
      return request.get('incomes/create');
    },

    createIncome(_, parameters) {
      return request.post('incomes', parameters);
    },

    updateIncome(_, parameters) {
      return request.put('incomes/' + parameters.id, parameters);
    },

    /**
     * Credit Management
     */
    getCreditDependencies() {
      return request.get('credits/create');
    },

    createCredit(_, parameters) {
      return request.post('credits', parameters);
    },

    updateCredit(_, parameters) {
      return request.put('credits/' + parameters.id, parameters);
    },

    changeCreditToIncome(_, payload) {
      return request.post('change-credit-to-income/' + payload.id, payload);
    },

    /**
     * Expense Management
     */
    expenseManagement(_, parameters) {
      return request.get('expenses', {
        params: parameters,
      });
    },

    getExpenseDependencies() {
      return request.get('expenses/create');
    },

    createExpense(_, parameters) {
      return request.post('expenses', parameters);
    },
    createPay(_, parameters) {
      return request.post('expenses/pay', parameters);
    },

    createGeneralExpense(_, parameters) {
      return request.post('generalExpenses', parameters);
    },

    updateExpense(_, parameters) {
      return request.put('expenses/' + parameters.id, parameters);
    },

    /**
     * Debt Management
     */
    getDebtDependencies() {
      return request.get('debts/create');
    },

    createDebt(_, parameters) {
      return request.post('debts', parameters);
    },

    updateDebt(_, parameters) {
      return request.put('debts/' + parameters.id, parameters);
    },

    // Global accoutning routes
    getAccountings(_, payload) {
      return request.get('accounting-report', {
        params: payload,
      });
    },
    getAdminAccountings(_, payload) {
      return request.get('admin-accounting-report', {
        params: payload,
      });
    },

    getSafe(_, payload) {
      return request.get('safe', {
        params: payload,
      });
    },
    getAdminSafe(_, payload) {
      return request.get('admin-safe', {
        params: payload,
      });
    },
    getStorage(_, payload) {
      return request.get('storage', {
        params: payload,
      });
    },
    getAccountingServices(_, payload) {
      return request.get('get-accounting-services', {
        params: payload,
      });
    },
    allUsers(_, payload) {
      return request.get('all-users', {
        params: payload,
      });
    },

    getAdminSafe(_, payload) {
      return request.get('admin-safe', {
        params: payload,
      });
    },

    getGeneralExpenses(_, payload) {
      return request.get('generalExpenses', {
        params: payload,
      });
    },

    editAccounting(_, id) {
      return request.get('incomes/' + id + '/edit');
    },

    changeAccountingType(_, payload) {
      return request.put('change-accounting-type', payload);
    },

    deleteAccounting(_, id) {
      return request.delete('incomes/' + id);
    },
    deleteStorage(_, id) {
      return request.delete('storage/' + id);
    },

    createReport(_, payload) {
      return request.post('create-report', payload);
    },

    createStorage(_, payload) {
      return request.post('storage', payload);
    },

    updateReport(_, payload) {
      return request.post('update-report', payload);
    },

    printExcel(_, payload) {
      return request.post('printsafeexcel', payload);
    },
  },
};
